import { Fragment, type SyntheticEvent } from "react";

import { classNames } from "@/utils/styling-utils";
import { Button } from "../base/button";
import { Heading } from "../base/heading";
import { Link } from "../base/link";
import { CheckIcon } from "../icons/icons";
import { HorizontalContainer } from "../layout/horizontal-container";
import { HorizontalSpacer } from "../layout/horizontal-spacer";
import { VerticalSpacer } from "../layout/vertical-spacer";
import { Image, type ImageProps } from "./image";
import { MapPinAndAddress } from "./map-pin-and-address";

interface SelectCenterButtonProps {
  address?: string;
  buttonText: string;
  facilities?: readonly string[] | string[];
  href?: string;
  onClick?: (e: SyntheticEvent) => void;
  selected?: boolean;
  title?: string;
  imageProps: ImageProps;
}

export const SelectCenterButton = ({
  address,
  buttonText,
  facilities,
  href,
  onClick,
  selected,
  title,
  imageProps,
}: SelectCenterButtonProps) => (
  <div className={classNames("select-center-button", selected && "select-center-button--selected")}>
    <Link href={href} onClick={onClick} textDecoration="none">
      <Image {...imageProps} />

      <div className="select-center-button__inner">
        <div className="select-center-button__inner__content">
          {title && <Heading type="h2">{title}</Heading>}

          {facilities && facilities.length > 0 && (
            <div className="select-center-button__inner__content__facilities">
              {facilities.slice(0, 3).map((facility) => (
                <Fragment key={facility}>
                  <HorizontalContainer noWrap={true} verticalPlacement="center">
                    <CheckIcon size="small" />
                    {facility}
                  </HorizontalContainer>
                  <VerticalSpacer />
                </Fragment>
              ))}
            </div>
          )}

          {address && (
            <div className="select-center-button__inner__content__address">
              <MapPinAndAddress address={address} />
              <HorizontalSpacer />
            </div>
          )}
        </div>

        <div className="select-center-button__inner__button">
          <Button buttonType="primary">{buttonText}</Button>
        </div>
      </div>
    </Link>
  </div>
);
